<template>
  <option :value="address">
    {{ addressTemplate }}
  </option>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component({
    name: 'checkout-address-option',
  })

  export default class extends Vue {
    @Prop() private address: object;

    private get streetLines(): string {
      const street = this.address['street'] ?? [];
      return ('string' === typeof street ? street.split("\n") : street).join(' ');
    }

    private get addressTemplate() {
      return this.address['firstname'] + (this.address['middlename'] ? ' ' + this.address['middlename'] : '') + ' ' + this.address['lastname'] + ', '
        + this.streetLines + ', '
        + this.address['postcode'] + ' ' + this.address['city'] + ', ' + (this.address['country_id'] ?? this.address['country_code'] ?? '');
    }
  }
</script>
